import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-213ff0e2")

_pushScopeId("data-v-213ff0e2")
const _hoisted_1 = { class: "ensure-service-explain" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("检测标准解读 ")
const _hoisted_4 = { class: "demo-tab-width-title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "demo-tab-width-line" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "ensure-table-tr tip"
}
const _hoisted_7 = {
  key: 1,
  class: "ensure-table-tr th"
}
const _hoisted_8 = {
  key: 2,
  class: "ensure-table-tr subth"
}
const _hoisted_9 = { class: "ensure-table-col col1" }
const _hoisted_10 = {
  key: 0,
  class: "ensure-table-tr th"
}
const _hoisted_11 = {
  key: 1,
  class: "ensure-table-tr subth"
}
const _hoisted_12 = { class: "ensure-table-colrow" }
const _hoisted_13 = { class: "ensure-table-colrow" }
const _hoisted_14 = { key: 2 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetectPlayer = _resolveComponent("DetectPlayer")
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_van_tabs = _resolveComponent("van-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ensure-service-explain-header",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _hoisted_2,
      _hoisted_3
    ]),
    _createVNode(_component_van_tabs, {
      modelValue: _ctx.state.activeName,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.activeName = $event)),
      scrollspy: "",
      sticky: "",
      class: "van-tabs__wrap--scrollable"
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.checkItemsExplain, (item) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            key: item.code,
            name: item.title
          }, {
            title: _withId(() => [
              _createVNode("span", null, [
                _createVNode("span", _hoisted_4, _toDisplayString(item.title), 1),
                _hoisted_5
              ])
            ]),
            default: _withId(() => [
              _createVNode("div", {
                class: ["ensure-section", [item.code]]
              }, [
                _createVNode("div", {
                  class: "ensure-title",
                  id: item.title
                }, _toDisplayString(item.title), 9, ["id"]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.definitionList, (items, idx) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "ensure-text",
                    key: `${item.code}_text${idx}`,
                    id: items.id ? items.id : ''
                  }, [
                    (items.type === 'table')
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          (items.tableData && items.tableType === 1)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                class: ["ensure-table table1", items.tableClass ? items.tableClass : ""]
                              }, [
                                (items.tableData.tip)
                                  ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(items.tableData.tip), 1))
                                  : _createCommentVNode("", true),
                                (items.tableData.title)
                                  ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(items.tableData.title), 1))
                                  : _createCommentVNode("", true),
                                (items.tableData.subTitle)
                                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(items.tableData.subTitle, (subItem, subidx) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: ["ensure-table-col", `col${subidx+1}`],
                                          key: `${item.code}_sub_${subidx}`
                                        }, _toDisplayString(subItem), 3))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(items.tableData.data, (dataItem, idx) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "ensure-table-tr",
                                    key: `${item.code}_data${idx}`
                                  }, [
                                    _createVNode("div", _hoisted_9, _toDisplayString(dataItem.itemTitle), 1),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataItem.list, (listItem, listIdx) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: ["ensure-table-col", `col${listIdx+2}`],
                                        key: `${item.code}_listItem_${listIdx}`,
                                        innerHTML: listItem
                                      }, null, 10, ["innerHTML"]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ], 2))
                            : _createCommentVNode("", true),
                          (items.tableData && items.tableType === 2)
                            ? (_openBlock(), _createBlock("div", {
                                key: 1,
                                class: ["ensure-table table2", items.tableClass ? items.tableClass : ""]
                              }, [
                                (items.tableData.title)
                                  ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(items.tableData.title), 1))
                                  : _createCommentVNode("", true),
                                (items.tableData.subTitle)
                                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(items.tableData.subTitle, (subItem, subidx) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: ["ensure-table-col", `col${subidx+1}`],
                                          key: `${item.code}_sub_${subidx}`
                                        }, _toDisplayString(subItem), 3))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(items.tableData.data, (dataItem, idx) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "ensure-table-tr",
                                    key: `${item.code}_data${idx}`
                                  }, [
                                    _createVNode("div", {
                                      class: ["ensure-table-col col1", dataItem.colspan ? `colspan${dataItem.colspan}` : '']
                                    }, _toDisplayString(dataItem.itemTitle), 3),
                                    _createVNode("div", _hoisted_12, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataItem.list, (listItem, listIdx) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "ensure-table-tr",
                                          key: `${item.code}_listItem_${listIdx}`
                                        }, [
                                          _createVNode("div", {
                                            class: ["ensure-table-col col2", {'empty': !listItem.itemTitle}]
                                          }, _toDisplayString(listItem.itemTitle), 3),
                                          _createVNode("div", _hoisted_13, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(listItem.list, (subcolitem, subcolIdx) => {
                                              return (_openBlock(), _createBlock("div", {
                                                class: "ensure-table-tr",
                                                key: `${item.code}_subcolitem_listItem_${subcolIdx}`
                                              }, [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(subcolitem, (subcolitemcont, subcolcontIdx) => {
                                                  return (_openBlock(), _createBlock("div", {
                                                    class: ["ensure-table-col", `col${subcolcontIdx+3}`],
                                                    key: `${item.code}_subcolitemcont_listItem_${subcolcontIdx}`,
                                                    innerHTML: subcolitemcont
                                                  }, null, 10, ["innerHTML"]))
                                                }), 128))
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                }), 128))
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (items.type === 'video')
                        ? (_openBlock(), _createBlock(_component_DetectPlayer, {
                            key: 1,
                            class: "DetectPlayer",
                            "play-data": _ctx.state.playData
                          }, null, 8, ["play-data"]))
                        : (_openBlock(), _createBlock("p", _hoisted_14, [
                            (items.title)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  style: items.titleStyle
                                }, _toDisplayString(items.title), 5))
                              : _createCommentVNode("", true),
                            _createVNode("i", {
                              innerHTML: items.text
                            }, null, 8, ["innerHTML"])
                          ]))
                  ], 8, ["id"]))
                }), 128))
              ], 2)
            ]),
            _: 2
          }, 1032, ["name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})